import API from "@/services/api/api.service";
import { RouteLocationNormalized } from "vue-router";

export const extraDefinitionResolver = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    try {
        const res = await API.getExtraDefinitions('patients', {lang: process.env.VUE_APP_LANG});
        to.meta.extra_definitions = res.data.data;
    } catch(error) {
        console.error('EXTRA_DEFINITION_RESOLVER_ERROR');
        return { name: 'Patients' };
    }
}